<template>
  <b-modal
    id="template_field_types_modal"
    @show="onShow"
    @hide="onClose"
    @hidden="resetDataModal"
    centered
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    scrollable
    size="lg"
  >
    <p class="h3 text-capitalize filterTittle">
      {{ $t("maintenance.field_types") }}
    </p>
    <hr />
    <div class="p-1">
      <div class="row row-cols-5 align-self-center containerSelect">
        <div
          v-for="fType in activeFieldTypes"
          :key="fType.type"
          class="col p-1 mx-1"
          :class="{ active: fieldType === fType.type }"
        >
          <label :for="fType.type" class="d-flex align-items-center column">
            <input
              :id="fType.type"
              type="radio"
              v-model="fieldType"
              :value="fType.type"
              class="fTypeSelector"
            />
            <img
              :src="require(`@/assets/images/icons/template-builder/${fType.icon}`)"
              alt="Icono"
              class="iconStyle"
            />
            <span class=""> {{ $t(fType.name) }} </span>
          </label>
        </div>
      </div>
    </div>

    <div>
      <template v-if="fieldTypeConfig && fieldTypeConfig.config.length">
        <hr />
        <div>{{ $t("maintenance.field_type_config") }}</div>
        <div class="pt-2 px-2">
          <field-type-config
            :field-type-cfg="fieldTypeCfg"
            :config="fieldTypeConfig"
            @update:data="onDataUpdated"
            @validation-changed="onValidationChanged"
          />
        </div>
      </template>
    </div>

    <template #modal-footer="{ close }">
      <b-button variant="danger" size="sm" @click="close()">
        {{ $t("close") }}
      </b-button>
      <b-button variant="primary" size="sm" @click="onApply(close)" :disabled="!isConfigValid">
        {{ $t("Apply") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, watch, getCurrentInstance } from "@vue/composition-api";
import FieldTypeConfig from "./FieldTypeConfig";
import { fieldTypes } from "./config";

export default {
  components: {
    BModal,
    vSelect,
    FieldTypeConfig,
  },
  props: {
    modalName: String,
    type: String,
    fieldTypeCfg: Object,
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy;
    const fieldType = ref();
    const fieldTypeConfig = ref();
    const fieldTypeConfigData = ref({ data: {} });
    const isConfigValid = ref(true);
    const activeFieldTypes = fieldTypes.filter((fType) => fType.type !== "facility");
    fieldTypeConfig.value = activeFieldTypes.find((fType) => fType.type === props.type);

    const validateNumberFields = () => {
      if (fieldType.value === "number") {
        const numberData = fieldTypeConfigData.value.data || {};
        const minValue = numberData.min;
        const maxValue = numberData.max;
        
        const isMinEmpty = minValue === null || minValue === undefined || minValue === "";
        const isMaxEmpty = maxValue === null || maxValue === undefined || maxValue === "";
        
        if (isMinEmpty || isMaxEmpty) {
          return false;
        }
        
        if (Number(minValue) >= Number(maxValue)) {
          return false;
        }
      }
      
      return true;
    };

    const onShow = () => {
      fieldType.value = props.type;
      isConfigValid.value = true;
    };
    const onClose = () => {};
    const resetDataModal = () => {
      isConfigValid.value = true;
    };
    const onDataUpdated = (data) => {
      fieldTypeConfigData.value = data;
      isConfigValid.value = validateNumberFields();
    };
    const onValidationChanged = (isValid) => {
      isConfigValid.value = isValid && validateNumberFields();
    };
    const onApply = (close) => {
      if (!isConfigValid.value) {
        return;
      }
      
      emit("selected");
      emit("update:type", fieldType.value);
      emit("update:fieldTypeCfg", fieldTypeConfigData.value);
      close();
    };

    watch(fieldType, (val) => {
      fieldTypeConfig.value = fieldTypes.find((fType) => fType.type === val);
      
      if (val === "number") {
        fieldTypeConfigData.value = { data: { min: null, max: null } };
        isConfigValid.value = false;
      } else {
        fieldTypeConfigData.value = { data: {} };
        isConfigValid.value = true;
      }
    });

    return {
      onShow,
      onClose,
      resetDataModal,
      onDataUpdated,
      onValidationChanged,
      onApply,
      fieldType,
      activeFieldTypes,
      fieldTypeConfig,
      isConfigValid,
    };
  },
};
</script>

<style lang="scss" scoped>
.fTypeSelector {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.4rem;
}

.iconStyle {
  width: 30px;
  height: 30px;
  margin-right: 5px;
}

.containerSelect :hover {
  background-color: #cce8ff;
  color: #1b3d5e;
  border-radius: 5px;
}

.active {
  background-color: #cce8ff;
  color: #1b3d5e;
  border-radius: 5px;
}

.dark-layout {
  color: white;

  .filterTitle {
    color: white;
  }

  .containerSelect :hover {
    background-color: #cce8ff;
    color: #1b3d5e;
  }

  .active span {
    color: #1b3d5e;
  }
}
</style>
